export const state = {
	users: [],
	currentUser: {},
};
